<section class="product-section text-white py-5">
  <div class="container d-flex flex-column flex-lg-row align-items-center pt-4">
    <div class="row d-flex justify-content-between align-items-center pt-4">
      <div class="col-md-12 col-lg-6 text-lg-start text-center">
        <h2 class="text-black">
          <span class="text-primary">{{ "ourproduct.title" | translate }}</span
          ><br />
          {{ "ourproduct.subtitle" | translate }}
        </h2>
        <p class="mt-3 text-black">
          {{ "ourproduct.paragh1" | translate }}
        </p>
      </div>

      <div class="col-md-12 col-lg-6 text-center pe-0">
        <img
          src="/public/data/Art.svg"
          alt="HilberTech Logo"
          class="product-img img-fluid animate__animated zoom-hover"
        />
      </div>
    </div>
  </div>
</section>
<!-- About Flight Fusion -->

<section class="about-flight text-white py-5">
  <div class="container d-flex flex-column flex-lg-row align-items-center pt-4">
    <div class="row d-flex justify-content-between align-items-center pt-4">
      <div class="col-md-12 col-lg-6">
        <img
          src="/public/data/Asset 4@2x-8 1.svg"
          alt="HilberTech Logo"
          class="img-fluid animate__animated zoom-hover"
        />
      </div>

      <div class="col-md-12 col-lg-6 text-lg-start text-center">
        <h2>{{ "ourproduct.title2" | translate }}</h2>
        <p class="mt-3">
          {{ "ourproduct.paragh2" | translate }}
        </p>
      </div>
    </div>
  </div>
</section>
<!-- About Business Travel -->
<section class="business-travel py-5">
  <div class="container py-5">
    <div
      class="progress mb-5"
      role="progressbar"
      aria-label="Example 1px high"
      aria-valuenow="25"
      aria-valuemin="0"
      aria-valuemax="100"
      style="height: 1px"
    >
      <div class="progress-bar" style="width: 25%"></div>
    </div>
    <div class="row">
      <!-- القائمة -->
      <div class="col-12 col-md-3 mb-3 mb-md-0">
        <ul class="nav flex-md-column flex-row justify-content-between">
          <li class="nav-item" *ngFor="let tab of tabs; let i = index">
            <a
              class="nav-link text-center text-md-start"
              [class.active]="activeTab === i"
              (click)="selectTab(i)"
            >
              {{ tab.title }}
            </a>
          </li>
        </ul>
      </div>

      <div class="col-12 col-md-9">
        <div *ngIf="activeTab === 0">
          <h2>{{ "ourproductdetails.title1" | translate }}</h2>
          <p>
            {{ "ourproductchallenges.details1" | translate }}
          </p>
          <p>
            {{ "ourproductchallenges.details2" | translate }}
          </p>
          <p>
            {{ "ourproductchallenges.details3" | translate }}
          </p>
        </div>
        <div *ngIf="activeTab === 1">
          <h2>{{ "ourproductdetails.title2" | translate }}</h2>
          <p>
            {{ "ourproductsolution.details1" | translate }}
          </p>
          <p>{{ "ourproductsolution.details2" | translate }}</p>
          <p>
            {{ "ourproductsolution.details3" | translate }}
          </p>
        </div>
        <div *ngIf="activeTab === 2">
          <h2>{{ "ourproductdetails.title3" | translate }}</h2>
          <ul class="dot-list">
            <li>{{ "ourproducttechnology.details1" | translate }}</li>
            <li>{{ "ourproducttechnology.details2" | translate }}</li>
            <li>{{ "ourproducttechnology.details3" | translate }}</li>
            <li>{{ "ourproducttechnology.details4" | translate }}</li>
          </ul>
        </div>
        <div *ngIf="activeTab === 3">
          <h2>{{ "ourproductdetails.title4" | translate }}</h2>
          <p>SaaS B2B Portal</p>
        </div>
      </div>
    </div>
  </div>
</section>

<!--  -->
<section class="contact">
  <app-contact-us-form></app-contact-us-form>
</section>
